import { render, staticRenderFns } from "./TourPricing.vue?vue&type=template&id=ce60bdce&"
import script from "./TourPricing.vue?vue&type=script&lang=js&"
export * from "./TourPricing.vue?vue&type=script&lang=js&"
import style0 from "./TourPricing.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TourPricing.vue"
export default component.exports